/**
 * Utility functions for Ajustes component
 */

export const getLocalId = (): number => {
  const userContext = localStorage.getItem('user');
  return userContext ? JSON.parse(userContext).local_id : 0;
};

export const validateTipValue = (value: string): boolean => {
  if (value === '') return true;
  const numericValue = parseFloat(value);
  return !isNaN(numericValue) && numericValue >= 0 && numericValue <= 100;
};
